import { BrandVoice } from 'common/interfaces/brandVoices'

import { connectInternalApi } from './api'

export type BrandToneResponse = {
  _id: string
  name: string
  description: string
  examples: string[]
}

export type BrandVoiceBE = {
  id: string
  name: string
  region_id: string
  default: boolean
  created: string
  last_updated: string
  brand_tones: BrandToneResponse[]
  language_settings?: { industry?: string }
}

export type BrandVoiceResponse = {
  msg: string
  brandVoices: BrandVoiceBE[]
}

export const mapBrandVoice = (brandVoice: BrandVoiceBE): BrandVoice => ({
  id: brandVoice.id,
  name: brandVoice.name,
  regionId: brandVoice.region_id.toLowerCase(),
  isDefault: brandVoice.default,
  createdDate: brandVoice.created,
  lastModified: brandVoice.last_updated,
  industry: brandVoice.language_settings?.industry ?? '',
  tones: [],
})

export const getBrandVoices = async ({
  accountId,
}: {
  accountId: string
}): Promise<BrandVoice[]> => {
  const result = await connectInternalApi.get<BrandVoiceResponse>(
    `v1/core/monorail/accounts/${accountId}/brand-voice`
  )
  const brandVoices = result.data.brandVoices ?? []

  return brandVoices.map(mapBrandVoice)
}
